import { useSyncExternalStore } from "react";

let activeRequestCount = 0;
const listeners = new Set<() => void>();

function emitChange() {
  for (const listener of listeners) listener();
}

export function beginServerRequest(): () => void {
  activeRequestCount += 1;
  emitChange();

  let ended = false;
  return () => {
    if (ended) return;
    ended = true;
    activeRequestCount = Math.max(0, activeRequestCount - 1);
    emitChange();
  };
}

export async function trackServerRequest<T>(
  request: () => Promise<T>,
): Promise<T> {
  const endRequest = beginServerRequest();
  try {
    return await request();
  } finally {
    endRequest();
  }
}

export function trackedFetch(
  input: RequestInfo | URL,
  init?: RequestInit,
): Promise<Response> {
  return trackServerRequest(() => globalThis.fetch(input, init));
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function getSnapshot() {
  return activeRequestCount;
}

export function useActiveServerRequestCount(): number {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}

export function resetServerRequestActivityForTests() {
  activeRequestCount = 0;
  emitChange();
}
